(() => {
  const root = document.querySelector('[data-belantara-tap]');

  if (!root) {
    return;
  }

  const params = new URLSearchParams(location.search);

  const signupFormId = root.dataset.signupFormId || 'Y3Qp2A';

  const panels = [...root.querySelectorAll('[data-tap-panel]')];

  const panelById = (id) => root.querySelector(`[data-tap-panel="${CSS.escape(id)}"]`);

  /*
   * Discover fragrances dynamically from Liquid.
   * JavaScript therefore does not need to know
   * which fragrances exist.
   */
  const fragranceIds = [...root.querySelectorAll('form[data-action="fragrance"]')].map(
    (form) => form.dataset.fragrance,
  );

  /*
   * Find whichever journey acts as the
   * fragrance picker.
   */
  const fragrancePicker =
    [...root.querySelectorAll('[data-tap-panel]')].find((panel) => {
      const hasNavigation = panel.querySelector('[data-tap-go]');

      const containsFragrance = fragranceIds.some((id) => panel.querySelector(`[data-tap-go="${CSS.escape(id)}"]`));

      return hasNavigation && containsFragrance;
    })?.dataset.tapPanel || 'fragrance-picker';

  /*
   * Backwards-compatible aliases for
   * existing NFC tags / URLs.
   */
  const aliases = {
    save_favourite: fragrancePicker,

    save_fragrance: fragrancePicker,

    fragrance: fragrancePicker,

    travel_size: 'travel',

    travel_sizes: 'travel',

    save_travel_interest: 'travel',

    travel: 'travel',

    refillable: 'refillables',

    refillables: 'refillables',

    save_refillable_interest: 'refillables',

    stay_close: 'stay-close',

    keep_in_touch: 'stay-close',

    subscribe: 'stay-close',

    mango: 'mango-butter',

    mango_butter: 'mango-butter',

    ingredient: 'mango-butter',

    star_ingredient: 'mango-butter',

    receipt: 'receipt',

    email_receipt: 'receipt',

    send_receipt: 'receipt',
  };

  const context = {
    source_type: params.get('src') || '',

    event_code: params.get('event') || '',

    venue_code: params.get('venue') || '',

    touchpoint_code: params.get('touchpoint') || '',

    product_code: params.get('product') || '',

    fragrance_code: params.get('fragrance') || '',

    intent_code: params.get('intent') || '',

    topic_code: params.get('topic') || '',

    tag_code: params.get('tag') || '',

    interaction_method: params.get('method') || 'nfc',
  };

  /*
   * The receipt token arrives in the URL
   * fragment so it never reaches a server
   * log or a referrer header.
   *
   * layout/theme.liquid lifts it off the
   * address bar into sessionStorage before
   * any analytics or pixel can record the
   * URL; this script runs deferred, far too
   * late to do that itself. The hash and
   * query are still read as a fallback, and
   * stripped if present.
   */
  const RECEIPT_TOKEN_KEY = 'belantara_receipt_token';

  const forgetReceiptToken = () => {
    try {
      sessionStorage.removeItem(RECEIPT_TOKEN_KEY);
    } catch (_) {}
  };

  const receiptToken = (() => {
    let stored = '';

    try {
      stored = sessionStorage.getItem(RECEIPT_TOKEN_KEY) || '';
    } catch (_) {}

    if (!stored) {
      stored = window.__belantaraReceiptToken || '';
    }

    const fromHash = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('token');

    const fromUrl = (fromHash || params.get('token') || '').trim();

    if (fromUrl) {
      try {
        window.history.replaceState(
          null,
          '',
          window.location.pathname + window.location.search.replace(/([?&])token=[^&]*/, '$1').replace(/[?&]$/, ''),
        );
      } catch (_) {}
    }

    return stored.trim() || fromUrl;
  })();

  /*
   * The token is a bearer credential for one
   * customer's receipt. It does not outlive
   * this page.
   */
  window.addEventListener('pagehide', forgetReceiptToken);

  const receiptEndpoint = (root.dataset.receiptEndpoint || '').trim();

  const clean = (object) =>
    Object.fromEntries(Object.entries(object).filter(([, value]) => value !== '' && value != null));

  const validEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

  /*
   * Navigation history is intentionally
   * internal to Tap.
   *
   * Direct NFC deep links start with an
   * empty history, therefore no misleading
   * Back button is shown.
   */
  let current = 'home';

  let history = [];

  /* =======================================================
     CUSTOMER RECOGNITION
     ======================================================= */

  function knownEmail() {
    if (window.BelantaraIdentity?.email) {
      return window.BelantaraIdentity.email(root.dataset.customerEmail);
    }

    const signedIn = (root.dataset.customerEmail || '').trim();

    if (signedIn) {
      return signedIn;
    }

    try {
      return (localStorage.getItem('belantara_tap_email') || '').trim();
    } catch (_) {
      return '';
    }
  }

  function remember(email) {
    if (window.BelantaraIdentity?.remember) {
      window.BelantaraIdentity.remember(email);

      return;
    }

    try {
      localStorage.setItem('belantara_tap_email', email);
    } catch (_) {}
  }

  /*
   * For unknown visitors:
   * show email field.
   *
   * For recognized visitors:
   * hide email field and show a subtle
   * continuity cue instead.
   */
  async function isRecognized() {
    if (window.BelantaraIdentity?.isKnown) {
      return window.BelantaraIdentity.isKnown(root.dataset.customerEmail);
    }

    return Boolean(knownEmail());
  }

  async function hydrateIdentity() {
    const email = knownEmail();

    const recognized = await isRecognized();

    root.querySelectorAll('.tap-email-slot').forEach((slot) => {
      slot.innerHTML = recognized
        ? ''
        : `
                <label
                  class="tap-field-label"
                >
                  ${root.dataset.emailLabel}
                </label>

                <input
                  class="tap-input"
                  name="email"
                  type="email"
                  inputmode="email"
                  autocomplete="email"
                  placeholder="${root.dataset.emailPlaceholder}"
                  required
                >
              `;
    });

    root.querySelectorAll('.tap-recognition-slot').forEach((slot) => {
      slot.innerHTML = recognized
        ? `
                <div
                  class="tap-recognized"
                  role="status"
                >

                  <span
                    class="tap-recognized__mark"
                    aria-hidden="true"
                  >
                    ✓
                  </span>

                  <span>
                    ${root.dataset.recognizedLabel}
                  </span>

                </div>
              `
        : '';
    });
  }

  /* =======================================================
     NAVIGATION
     ======================================================= */

  function setBackVisibility() {
    panels.forEach((panel) => {
      const back = panel.querySelector('[data-tap-back]');

      if (!back) {
        return;
      }

      /*
       * An NFC tag is a deep link: the visitor
       * arrives directly on this panel with no
       * internal history, so there is nowhere
       * for Back to go and it is not shown.
       */
      const hide = panel.hidden || history.length === 0;

      back.hidden = hide;

      const navigation = back.closest('[data-tap-navigation]');

      if (navigation) {
        navigation.hidden = hide;
      }
    });
  }

  function show(id, { push = true } = {}) {
    if (!panelById(id)) {
      id = 'home';
    }

    if (push && current && current !== id) {
      history.push(current);
    }

    current = id;

    panels.forEach((panel) => {
      panel.hidden = panel.dataset.tapPanel !== id;
    });

    setBackVisibility();

    hydrateIdentity();

    hydrateReceipt();

    window.scrollTo(0, 0);
  }

  function goBack() {
    const previous = history.pop();

    if (previous) {
      show(previous, {
        push: false,
      });
    }
  }

  /* =======================================================
     KLAVIYO
     ======================================================= */

  function identify(email, properties) {
    const payload = clean({
      email,
      ...properties,
    });

    if (window.klaviyo?.identify) {
      return Promise.resolve(window.klaviyo.identify(payload));
    }

    window._learnq = window._learnq || [];

    window._learnq.push([
      'identify',
      clean({
        $email: email,
        ...properties,
      }),
    ]);

    return Promise.resolve();
  }

  function track(name, properties) {
    if (window.klaviyo?.track) {
      return Promise.resolve(window.klaviyo.track(name, clean(properties)));
    }

    window._learnq = window._learnq || [];

    window._learnq.push(['track', name, clean(properties)]);

    return Promise.resolve();
  }

  /* =======================================================
     SAVE
     ======================================================= */

  async function save(form) {
    const input = form.querySelector('input[name="email"]');

    /*
     * The email field is only rendered for a
     * visitor we do not recognise, so its
     * presence is exactly "they gave us their
     * email on this screen".
     */
    const gaveEmail = Boolean(input);

    const recognized = await isRecognized();

    const email = (input ? input.value : knownEmail()).trim().toLowerCase();

    const error = form.querySelector('[data-tap-error]');

    if (!recognized && !validEmail(email)) {
      error.textContent = root.dataset.invalidEmail;

      input?.focus();

      return;
    }

    const action = form.dataset.action;

    const profileKey = form.dataset.profileKey;

    const fragrance = form.dataset.fragrance || context.fragrance_code;

    const profile = {};

    const eventProperties = {
      action: form.dataset.eventAction || '',
    };

    /*
     * Fragrance saves store the actual
     * fragrance code as the profile value.
     *
     * Generic preference journeys store true.
     */
    if (action === 'fragrance') {
      if (profileKey) {
        profile[profileKey] = fragrance;
      }

      eventProperties.fragrance_code = fragrance;

      eventProperties.fragrance_label = panelById(fragrance)?.querySelector('.tap-title')?.textContent.trim() || '';
    } else {
      if (profileKey) {
        profile[profileKey] = true;
      }

      if (form.dataset.interestType) {
        eventProperties.interest_type = form.dataset.interestType;
      }
    }

    const button = form.querySelector('button[type="submit"]');

    const original = button.textContent;

    button.disabled = true;

    button.textContent = root.dataset.savingLabel;

    error.textContent = '';

    try {
      const brief = window.BelantaraTapBrief?.payload(context);

      if (!brief) {
        button.disabled = false;

        button.textContent = original;

        error.textContent = root.dataset.eventContextError || root.dataset.genericError;

        return;
      }

      if (validEmail(email)) {
        await identify(
          email,
          clean({
            in_person_acquired: true,

            last_in_person_event: context.event_code,

            last_in_person_venue: context.venue_code,

            last_in_person_date: new Date().toISOString(),

            ...brief.profile,

            ...profile,
          }),
        );
      }

      await track(
        form.dataset.eventName || 'In Person — Expressed Interest',

        clean({
          ...context,

          ...eventProperties,

          ...brief.event,
        }),
      );

      if (email) {
        remember(email);
      }

      root.querySelector('[data-saved-message]').textContent = form.dataset.confirmation || '';

      const savedActions = root.querySelector('[data-tap-saved-actions]');

      if (savedActions) {
        savedActions.hidden = !gaveEmail;
      }

      /*
       * Saved is treated as the end
       * of the current navigation path.
       */
      history = [];

      show('saved', {
        push: false,
      });
    } catch (_) {
      button.disabled = false;

      button.textContent = original;

      error.textContent = root.dataset.genericError;
    }
  }

  /* =======================================================
     RECEIPT
     ======================================================= */

  /*
   * The receipt journey is deliberately
   * separate from save().
   *
   * It never calls identify or track, never
   * touches a Klaviyo list and never records
   * marketing consent. Sending a receipt is
   * fulfilment, not a relationship.
   */
  function hydrateReceipt() {
    const input = root.querySelector('[data-tap-receipt-form] input[name="email"]');

    if (!input) {
      return;
    }

    /*
     * A recognised address is offered as a
     * convenience only. The field stays
     * visible and editable, and anything the
     * customer has typed is never replaced.
     */
    if (input.dataset.tapTouched === 'true' || input.value) {
      return;
    }

    input.value = knownEmail();
  }

  async function sendReceipt(form) {
    const input = form.querySelector('input[name="email"]');

    const error = form.querySelector('[data-tap-error]');

    const email = (input?.value || '').trim().toLowerCase();

    if (!validEmail(email)) {
      error.textContent = root.dataset.invalidEmail;

      input?.focus();

      return;
    }

    /*
     * Without a token there is nothing to bind
     * the request to a paid order, so the
     * customer is sent to a person rather than
     * shown a technical explanation.
     */
    if (!receiptToken || !receiptEndpoint) {
      error.textContent = root.dataset.receiptError;

      return;
    }

    const button = form.querySelector('button[type="submit"]');

    const original = button.textContent;

    button.disabled = true;

    button.textContent = root.dataset.receiptSendingLabel;

    error.textContent = '';

    try {
      const response = await fetch(receiptEndpoint, {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },

        body: JSON.stringify({
          email: email,

          token: receiptToken,
        }),
      });

      /*
       * "Sent" only when the relay says an
       * email actually went: HTTP 2xx, ok:true
       * AND sent:true. Anything else, including
       * {ok:true, sent:false}, 'no_order', or a
       * body that is not JSON, shows the
       * receipt error copy. No order detail is
       * expected or displayed.
       */
      let accepted = false;

      if (response.ok) {
        try {
          const body = await response.json();

          accepted = Boolean(body && body.ok === true && body.sent === true);
        } catch (_) {}
      }

      if (!accepted) {
        throw new Error('receipt');
      }

      forgetReceiptToken();

      const consentCheckbox = form.querySelector('input[name="marketing_consent"]');

      const marketingConsentRequested = Boolean(consentCheckbox?.checked);

      let marketingConsentSaved = !marketingConsentRequested;

      if (marketingConsentRequested) {
        try {
          const marketingConsent = window.BelantaraTapMarketingConsent;

          if (!marketingConsent?.subscribe) {
            throw new Error('marketing-consent');
          }

          await marketingConsent.subscribe(email);

          marketingConsent.rememberConsent?.(email);

          marketingConsentSaved = true;
        } catch (_) {}
      }

      history = [];

      show('receipt-sent', {
        push: false,
      });

      if (marketingConsentRequested && !marketingConsentSaved) {
        const sentLead = panelById('receipt-sent')?.querySelector('.tap-lead');

        if (sentLead) {
          sentLead.textContent = root.dataset.receiptConsentError;
        }
      }
    } catch (_) {
      button.disabled = false;

      button.textContent = original;

      error.textContent = root.dataset.receiptError;
    }
  }

  root.addEventListener('input', (event) => {
    const field = event.target.closest('[data-tap-receipt-form] input[name="email"]');

    if (field) {
      field.dataset.tapTouched = 'true';
    }
  });

  root.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-tap-receipt-form]');

    if (!form) {
      return;
    }

    event.preventDefault();

    sendReceipt(form);
  });

  /* =======================================================
     CLICK ROUTING
     ======================================================= */

  root.addEventListener('click', (event) => {
    const go = event.target.closest('[data-tap-go]');

    if (go) {
      return show(go.dataset.tapGo);
    }

    if (event.target.closest('[data-tap-back]')) {
      return goBack();
    }

    if (event.target.closest('[data-open-klaviyo]')) {
      window._klOnsite = window._klOnsite || [];

      window._klOnsite.push(['openForm', signupFormId]);
    }
  });

  /* =======================================================
     FORM ROUTING
     ======================================================= */

  root.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-tap-form]');

    if (!form) {
      return;
    }

    event.preventDefault();

    save(form);
  });

  /* =======================================================
     INITIAL ROUTING
     ======================================================= */

  /*
   * Known aliases are translated first.
   *
   * Otherwise the actual intent value is
   * treated as a journey ID. This is what
   * makes new admin-created journeys work
   * with direct NFC URLs without JS changes.
   */
  const mappedIntent = aliases[context.intent_code] || context.intent_code;

  /*
   * Specific fragrance URL:
   *
   * ?intent=save_fragrance
   * &fragrance=fpam
   *
   * goes straight to that fragrance.
   */
  const directFragrance =
    context.fragrance_code && fragranceIds.includes(context.fragrance_code) && mappedIntent === fragrancePicker;

  const initial = directFragrance ? context.fragrance_code : panelById(mappedIntent) ? mappedIntent : 'home';

  /*
   * Deep links have no internal navigation
   * history, therefore no Back button.
   */
  current = initial;

  history = [];

  panels.forEach((panel) => {
    panel.hidden = panel.dataset.tapPanel !== initial;
  });

  setBackVisibility();

  hydrateIdentity();

  hydrateReceipt();
})();
